import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddEnterpriseGroupForm from './AddEnterpriseGroupForm';

const AddEnterpriseGroupModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Add Enterprise Group</ModalHeader>
      <ModalBody>
        <AddEnterpriseGroupForm />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEnterpriseGroupModal;
